import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import FilterChip from './FilterChip';
import { FilterType } from './FilterDictionary';
import { selectDataTableFilters } from '@/redux/selectors/dataTableSelectors';
import { applyFilter } from '@/redux/slices/dataTableSlice';
import { Menu, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

interface FilterNullableBooleanProps {
  data: FilterType;
}

const FilterNullableBoolean = ({ data }: FilterNullableBooleanProps) => {
  const hasPermissions = data.role ? useAppSelector(data.role) : true;
  const { label, id } = data;
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectDataTableFilters);
  const [value, setValue] = useState(filters[id] || null);
  const handleClick = (event: any) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const options = {
    ['Yes']: true,
    ['No']: false
  };

  const invertedOptions = Object.entries(options).reduce((acc, [key, value]) => {
    acc[String(value)] = key;
    return acc;
  }, {} as { [key: string]: string });

  const handleMenuItemClick = (e: any) => {
    const newValue = options[e.target.textContent as keyof typeof options];
    setValue(newValue);
    dispatch(applyFilter({ type: id, selections: newValue }));
    setAnchorEl(null);
  };

  const handleClear = (e: any) => {
    e.stopPropagation();
    dispatch(applyFilter({ type: id, selections: null }));
    setValue(null);
  };

  return hasPermissions ? (
    <div style={{ marginRight: 10 }}>
      <FilterChip
        label={
          <>
            {label}: <strong style={{ marginLeft: 5 }}>{value === null ? 'All' : invertedOptions[value]}</strong>
          </>
        }
        isSelected={value !== null}
        onClick={handleClick as any}
        onClear={handleClear as any}
      />

      <Menu
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        variant="menu"
      >
        {Object.keys(options).map((optionKey) => {
          return (
            <MenuItem
              selected={value === options[optionKey as keyof typeof options]}
              key={optionKey}
              id={optionKey}
              onKeyDown={(e) => e.stopPropagation()}
              onClick={handleMenuItemClick}
            >
              {optionKey}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  ) : (
    <></>
  );
};

export default FilterNullableBoolean;
